export default function FinalCTASection() {
  return (
    <>
      <section className="relative bg-gradient-to-br from-[#991B1B] via-[#7F1D1D] to-[#0F172A] py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-red-500/10 blur-3xl -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-amber-500/8 blur-3xl translate-y-1/2 -translate-x-1/3"></div>
        <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-8 text-center">
          <p className="text-red-400 text-xs font-bold uppercase tracking-[0.25em] mb-4">Don't Wait</p>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
            Don't Wait — <span className="text-red-400">Every Hour Counts</span>
          </h2>
          <p className="text-white/70 text-lg mb-8 leading-relaxed">
            In a passport emergency, the biggest mistake is waiting to see what happens. The earlier you call, the more options we have. Fast Passport Center has solved passport emergencies for over 20 years — from travelers with a week to spare to people with a flight in 36 hours. Call us now and we'll tell you exactly what's possible for your situation.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a
              href="tel:8772530084"
              className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold text-lg px-10 py-5 rounded-md transition-all hover:scale-105 whitespace-nowrap shadow-lg shadow-red-900/40"
            >
              <i className="ri-phone-line text-xl"></i> Call 877-253-0084 Now
            </a>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 border-2 border-white/30 hover:border-white text-white hover:text-white font-bold text-lg px-10 py-5 rounded-md transition-all whitespace-nowrap"
            >
              <i className="ri-shopping-cart-line"></i> Start Emergency Order Online
            </a>
          </div>

          <p className="text-white/50 text-sm mb-10">
            Available Monday–Friday, 8AM–6PM EST. Start your order online anytime — we process first thing next business morning.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6">
            {[
              { icon: "ri-shield-check-line", text: "Registered State Dept. Courier" },
              { icon: "ri-award-line", text: "A+ BBB" },
              { icon: "ri-calendar-check-line", text: "20+ Years" },
              { icon: "ri-user-voice-line", text: "Real Humans Answer" },
              { icon: "ri-building-line", text: "Daily Agency Access" },
            ].map((badge, i) => (
              <div key={i} className="flex items-center gap-2 text-white/50 text-xs">
                <i className={`${badge.icon} text-red-400`}></i>
                <span>{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <footer className="bg-[#0F2240] text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-2">
              <a href="https://fastpassportcenter.com">
                <img
                  src="https://staging.fastpassportcenter.com/wp-content/uploads/2026/02/Footer.svg"
                  alt="Fast Passport Center"
                  className="h-8 w-auto mb-4"
                />
              </a>
              <p className="text-white/50 text-sm leading-relaxed mb-4 max-w-sm">
                Fast Passport Center is an approved and registered U.S. Department of State passport courier providing expedited and emergency passport services nationwide.
              </p>
              <div className="flex items-center gap-3">
                <a href="https://www.facebook.com/fastpassportcenter/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-red-600 hover:text-white text-white transition-all">
                  <i className="ri-facebook-fill text-sm"></i>
                </a>
                <a href="https://x.com/fpcnews" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-red-600 hover:text-white text-white transition-all">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
                <a href="https://www.instagram.com/fastpassportcenter/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-red-600 hover:text-white text-white transition-all">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-bold text-sm uppercase tracking-wide text-red-400 mb-4">Services</h4>
              <ul className="space-y-2">
                {[
                  ["Emergency Passport", "/passport-services/emergency-passport/"],
                  ["Expedited Passport", "/passport-services/expedited-passport-service/"],
                  ["New Passport", "/passport-services/new-passport/"],
                  ["Passport Renewal", "/passport-services/renewal/"],
                  ["Lost/Stolen Passport", "/passport-services/lost-stolen/"],
                  ["Child Passport", "/passport-services/child-passport/"],
                  ["Damaged Passport", "/passport-services/damaged-passport/"],
                  ["Name Change", "/passport-services/name-change/"],
                ].map(([label, url]) => (
                  <li key={url}>
                    <a
                      href={url}
                      className="text-white/50 hover:text-red-400 text-sm transition-colors whitespace-nowrap"
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-sm uppercase tracking-wide text-red-400 mb-4">Contact</h4>
              <ul className="space-y-3">
                <li>
                  <a href="tel:8772530084" className="flex items-start gap-2 text-white/50 hover:text-red-400 text-sm transition-colors">
                    <i className="ri-phone-line mt-0.5 flex-shrink-0"></i>
                    <span>877-253-0084</span>
                  </a>
                </li>
                <li>
                  <a href="mailto:contactus@fastpassportcenter.com" className="flex items-start gap-2 text-white/50 hover:text-red-400 text-sm transition-colors">
                    <i className="ri-mail-line mt-0.5 flex-shrink-0"></i>
                    <span>contactus@fastpassportcenter.com</span>
                  </a>
                </li>
                <li className="flex items-start gap-2 text-white/50 text-sm">
                  <i className="ri-time-line mt-0.5 flex-shrink-0"></i>
                  <span>Mon–Fri, 8AM–6PM EST</span>
                </li>
                <li className="flex items-start gap-2 text-white/50 text-sm">
                  <i className="ri-map-pin-line mt-0.5 flex-shrink-0"></i>
                  <span>1629 K Street, Suite 300<br />Washington, DC 20006</span>
                </li>
              </ul>
              <div className="mt-6">
                <img
                  src="https://staging.fastpassportcenter.com/wp-content/uploads/2026/01/bbb.png"
                  alt="BBB A+ Rating"
                  className="h-12 w-auto opacity-70"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-white/30 text-xs">
              &copy; 2026 Fast Passport Center. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://fastpassportcenter.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/60 text-xs transition-colors whitespace-nowrap">Privacy Policy</a>
              <a href="https://fastpassportcenter.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/60 text-xs transition-colors whitespace-nowrap">Terms &amp; Conditions</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}